<template>
<div>
  <Topnav/>

  <div class="header-dark text-center">
    <div class="container hero">
      <div class="row">
        <div class="col-md-8 offset-md-2 text-center">
          <h1>Telegram chatbot creator</h1>
          <h4 class="mb-5">Simple yet powerful codeless Telegram bot creator</h4>
          <button class="btn btn-outline-primary active" type="button" data-bs-hover-animate="tada" style="margin:20px auto;color:#ffffff;background-color:#000000;" @click="toBotsPage">Create chatbot for free</button>
        </div>
      </div>
    </div>
  </div>

  <div class="highlight-phone">
    <div class="container">
      <div class="row">
        <div class="col-md-8" data-aos="fade" data-aos-duration="1000">
          <div class="intro">
            <h2>your virtual Assistant</h2>
            <p>Virtual Assistant for Telegram channel admins. 
              Automate conversations with your users and provide better customer experience.</p>

            <p>Telegram is the most convinient and powerful tool to reach your customers.</p>

            <p>Telegram is able to increase the interest of the target audience to both your products and the brand in general.</p>
            
            <a class="btn btn-primary" role="button" data-aos="zoom-in" @click="toBotsPage">Create Chatbot</a>

          </div>
        </div>
        <div class="col-sm-4" data-aos="fade-up-left" data-aos-duration="1000">
          <div class="d-none d-md-block iphone-mockup"><img src="assets/img/iphone.svg" class="device">
            <div class="screen"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid my-5 px-5">
    <div class="container text-center mb-5" data-aos="zoom-in">
      <h1>Useful Inbuilt Features</h1>
    </div>

    <div class="row" >
      <div class="col">
        <div class="container mb-5" data-aos="fade-up" data-aos-duration="1000">
          <h2 class="mb-3">Prime Member</h2>
          <p>You can make your bot features accessible to only specific users for a certain period.<br>
          Easily add and maintain your prime members.</p>
        </div>

        <div class="container mb-5" data-aos="fade-up" data-aos-duration="1000">
            <h2 class="mb-3">Broadcast</h2>
            <p>Notify the bot users about any updates or news of your company.<br>
            This is the fastest way to reach your customers.</p>
        </div>

        <div class="container mb-5" data-aos="fade-up" data-aos-duration="1000">
            <h2 class="mb-3">Schedule</h2>
            <p>Schedule your bot to run periodically on every minute or every hour or
              every day to automate repetitive tasks.<br>
              For example, posting content to your channel on every hour.</p>
        </div>
      </div>

      <div class="col">
          <div class="container mb-5" data-aos="fade-up" data-aos-duration="1000">
              <h2 class="mb-3">Monitor</h2>
              <p>View detailed information about the bot subscribers.<br>
              Keep an eye on the bot's daily incoming and outgoing messages.<br>
              Get statistics of the subscribers and referrals.</p>
          </div>

          <div class="container mb-5" data-aos="fade-up" data-aos-duration="1000">
              <h2 class="mb-3">Admins</h2>
              <p>Make some of the bot's features accessible only by admins.<br>
              Add any number of admins to your bot.</p>
          </div>

          <div class="container mb-5" data-aos="fade-up" data-aos-duration="1000">
              <h2 class="mb-3">Referrals</h2>
              <p>Users can refer your bot with their referral links.<br>
              You can see all referral data in one place and reward the top referral.</p>
          </div>
      </div>

    </div>
  </div>

  

  <div class="highlight-blue">
    <div class="container">
      <div class="row">
        <div class="col col-xl-4 col-sm-12 col-12">
          <div class="jumbotron text-center">
            <h1 data-aos="fade-up" data-aos-duration="1000" style="font-size:100px;">{{bots}}</h1>
            <h1>bots online</h1>
          </div>
        </div>
        <div class="col col-xl-4 col-sm-12 col-12">
          <div class="jumbotron text-center">
            <h1 data-aos="fade-up" data-aos-duration="1000" style="font-size:100px;">{{users}}</h1>
            <h1>users</h1>
          </div>
        </div>
        <div class="col col-xl-4 col-sm-12 col-12">
          <div class="jumbotron text-center">
            <h1 data-aos="fade-up" data-aos-duration="1000" style="font-size:100px;">{{messages}}</h1>
            <h1>conversations</h1>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid my-5 px-5" data-aos="zoom-in">
    <div class="jumbotron text-center">
      <h1>Get your bot developed by us at just $30</h1>
      <h1>or</h1>
      <h1>Create on your own for free</h1>
      <div class="mt-5">
        <a class="btn btn-primary" role="button" href="https://t.me/hackspider" target="_blank">Contact Now</a>
      </div>
      

    </div>
  </div>
  
  <div class="newsletter-subscribe" style="background-image:url(&quot;assets/img/envelope.jpg&quot;);">
    <div class="container" data-aos="fade" data-aos-duration="1000">
      <div class="intro">
        <h2 class="text-center">Subscribe to our Telegram channel to connect with us</h2>
        <p class="text-center text-dark">and recieve our latest updates</p>
      </div>
      <form class="form-inline" method="post" data-aos="zoom-in" data-aos-duration="1000">
        <div class="form-group"><a class="btn btn-primary" role="button" href="https://t.me/+VTcjsr0skKyFa3oO" target="_blank" data-bs-hover-animate="rubberBand">Subscribe to our channel</a></div>
        <div class="form-group"><a class="btn btn-primary" role="button" href="https://t.me/Chatbotcreatorbot" target="_blank" data-bs-hover-animate="rubberBand">Say hi to our bot</a></div>
      </form>
    </div>
  </div>
  
  <Footer></Footer>
</div>
</template>


<script>
// @ is an alias to /src
import ApiService from '@/services/ApiService'
import Topnav from "@/components/Topnav.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: 'home',
  components:{
    Topnav,
    Footer
  },
  data: function() {
    return {
      bots: '...',
      users: '...',
      messages: '...'
    }
  },
  methods: {
    toBotsPage: function() {
      this.$router.push({
        path: '/bots'
      })
    },
    getCompanyStat: function() {
      ApiService.getCompanyStats()
        .then(function(result) {
          this.bots = this.formatBigNumber(result.bots)
          this.users = this.formatBigNumber(result.users)
          this.messages = this.formatBigNumber(result.messages)
        }.bind(this))
        .catch(function(response) {
          this.$dialog.alert(response.description)
        }.bind(this))
    },
    formatBigNumber(num) {
      if (num < 1000) {
        return num
      } else if (num >= 1000 && num < 1000000) {
        let n = num/1000
        let s = n.toString()
        return s.substring(0, 4) + 'K'
      } else if (num >= 1000000 && num < 1000000000) {
        let n = num/1000000
        let s = n.toString()
        return s.substring(0, 4) + 'M'
      } else if (num >= 1000000000 && num < 1000000000000) {
        let n = num/1000000000
        let s = n.toString()
        return s.substring(0, 4) + 'B'
      } else {
        return num
      }
    }
  },
  mounted() {
    this.getCompanyStat()
  }
}
</script>
